import styled from '@emotion/styled';

interface Document {
	name: string;
	url: string;
}

const Section = styled.section`
	padding: 2rem 1.5rem 4rem;
`;

const Title = styled.h2`
	font-size: 2rem;
	text-transform: uppercase;
	letter-spacing: 0.2em;
	margin-bottom: 1.5rem;
`;

const List = styled.div`
	display: grid;
	gap: 1rem;
	max-width: 48rem;
`;

const Item = styled.a`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1rem 1.5rem;
	border: 1px solid #111827;
	text-decoration: none;
	color: inherit;
`;

export default function DocumentBlockDelta({ documents }: { documents: Document[] }) {
	if (documents.length === 0) return null;

	return (
		<Section id="documents">
			<Title>Documents</Title>
			<List>
				{documents.map((doc) => (
					<Item key={doc.url} href={doc.url} target="_blank" rel="nofollow">
						<span>{doc.name}</span>
						<span>→</span>
					</Item>
				))}
			</List>
		</Section>
	);
}
